import ThankYouHandler from '@/handlers/ThankYouHandler';
import CurrencyHandler from '@/handlers/CurrencyHandler';
import PlagiarismReportPageViewHandler from '@/handlers/PlagiarismReportPageViewHandler';
import SampleEditFeedbackHandler from '@/handlers/SampleEditFeedbackHandler';

const handlers = [
    // string: Event, string: EventHandlerFunction, class: EventHandlerClass
    ['post_thank_you', 'post', ThankYouHandler],
    ['post_sample_edit_feedback', 'post', SampleEditFeedbackHandler],
    ['changeCurrency', 'changeCurrency', CurrencyHandler],
    ['page-view:plagiarism-order:report', 'handle', PlagiarismReportPageViewHandler],
    ['page-view:plagiarism-example:report', 'handleExample', PlagiarismReportPageViewHandler],
    ['track-event:plagiarism-order:ai-content-detector-opened', 'handleAIContentDetectorModalOpened', PlagiarismReportPageViewHandler],
    ['paraphraser_added_to_pc_order', 'toggleAddParaphraserToPcOrder', PlagiarismReportPageViewHandler],
];

export default function (nuxt) {
    handlers.forEach(({ 0: eventName, 1: eventCallback, 2: EventCallbackClass }) => {
        nuxt.store.$bus.$on(eventName, async (data) => {
            (new EventCallbackClass(nuxt))[eventCallback](data);
        });
    });
}
